import { DisplayKeyParagraphModel } from "../../desktop/models/display-key-paragraph";
import { AuthorizedCollection } from "../../authentication/models/authorized-collection";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: DisplayKeyParagraphModel
})
export class DisplayKeyParagraphCollection extends AuthorizedCollection {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/collections/display-key-paragraphs.ts